<sd-form checkbox
  [labelTitle]="'order.return.detail.selectProduct' | translate"
  [labelHidden]="true"
  [disabled]="readonly || product.isDisabled "
  [(checked)]="checkValue"
  [ngStyle]="{'top': + alignItems + 'px'}"
  nameField="checkProductToReturn"
  (checkedChange)="checkedChange()"
/>

<div class="c__wrapper {{product.isDisabled ? 'is-disabled' : ''}}">
  <sd-product-customer
    #productCustomer
    (click)="toggleCheck()"
    [indexFollow]="product?.productInfo?.indexFollow !== undefined ? product?.productInfo?.indexFollow : true"
    [titleLevel]="product.titleLevel"
    [isReadOnly]="true"
    [isMinified]="true"
    [productInfo]="product.productInfo"
    (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
  />
  @if (product.disabledTitle) {
    <p class="is-caption c__disabled-title">{{ product.disabledTitle }}</p>
  }
  @if (checkValue) {
    <div class="c__select-cause" [ngStyle]="isTablet$ ? '' : {'top': + alignItems + 'px'}">
      <sd-form select
        class="c__quantity"
        #qtySelector
        [disabled]="readonly"
        [items]="itemQty"
        [labelTitle]="'product.a11y.quantity' | translate: { productName: product?.productInfo?.title, productCode: product?.productInfo?.code }"
        valueKey="value"
        [selectedValue]="{value: (product.productInfo.quantity ? product.productInfo.quantity : 1)}"
        libelleKey="value"
        nameField="selectQuantity"
      />
      <sd-form select
        #reasonSelector
        (valueChanged)="updateReason()"
        class="c__reason"
        [disabled]="readonly"
        [items]="returnListConfig.items"
        [labelTitle]="'order.return.detail.selectReason' | translate"
        [isSmall]="returnListConfig.isSmall"
        [isOpened]="returnListConfig.isOpened"
        [valueKey]="returnListConfig.valueKey"
        [libelleKey]="returnListConfig.libelleKey"
        [nameField]="'reason-'+ uuidSelect"
        [required]="returnListConfig.required"
        [placeholder]="'order.return.detail.placeholder' | translate"
      >
        <sd-form-error sd-message
          [control]="reasonSelector.internalField"
          class="is-visually-hidden"
          errorKey="required"
          [errorLabel]="'order.return.error' | translate"
        />
      </sd-form>
    </div>
  }
</div>
